<template>
  <div class="order-pick">
    <div class="pick-title">{{ orderPickInfo.title }}</div>
    <div class="pick-title_sub">{{ orderPickInfo.subTitle }}</div>
    <div class="pick-list_content" v-if="orderPickInfo.showList && orderPickInfo.showList.length">
      <div
        v-for="(item, index) in orderPickInfo.showList"
        :key="index"
        class="pick-list_item"
      >
        <div class="item-key">{{ item.key }}</div>
        <div class="item-value">{{ item.value[0] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderPick',
  props: {
    orderPickInfo: Object,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
